import { ListingStatus, ListingType, PipelineStatus } from '@app/models/enums'
import classNames from 'classnames'
import * as React from 'react'
import './ListingTypeBox.scss'

export interface IListingTypeBoxProps {
  className?: string
  status: ListingStatus | PipelineStatus
  style?: React.CSSProperties
  type: ListingType
}

export class ListingTypeBox extends React.PureComponent<IListingTypeBoxProps> {
  public render() {
    const boxClasses = classNames(this.props.className, 'listing-type-box', {
      active: this.props.status === ListingStatus.Active || this.props.status === PipelineStatus.Active,
      closed: this.props.status === PipelineStatus.Closed,
      expired: this.props.status === ListingStatus.Expired,
      pending: this.props.status === ListingStatus.Pending,
      sold: this.props.status === ListingStatus.Sold,
    })

    return (
      <div className={boxClasses} style={this.props.style}>
        <p>{this.props.type?.substring(0, 1)}</p>
      </div>
    )
  }
}
